import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import ComponentLayout from '../../../src/layouts/component-layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/435f104b-47a5-49d8-9568-6825f2b3789c",
        "alt": "An image showing different button types."
      }}></img></p>
    <h2>{`Usage`}</h2>
    <p>{`Buttons allow users to initiate an action or command when clicked. The button's label or text description indicates the purpose of the action to the user. Most of the time, we use the "Default" button type, but other types of buttons may be used to indicate something special about the button's hierarchy or functionality.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/1cbc4eed-6047-4e4a-a38d-11b6ffba3a67" />
    <Caption mdxType="Caption">Keep button labels succinct with no line breaks.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/5b2562b7-b6eb-4930-8b7d-3607379b0e3c" />
    <Caption mdxType="Caption">
      Buttons should never contain line breaks and lose their button shape.
    </Caption>
  </Dont>
    </DoDontContainer>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/6a112917-5fed-4c30-ad22-e1f3c437d50b" />
    <Caption mdxType="Caption">Show focus styles on keyboard :focus</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/01e53312-c2cb-4128-937f-01e4c313362c" />
    <Caption mdxType="Caption">Don't remove default button :focus styles.</Caption>
  </Dont>
    </DoDontContainer>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/e0bf58f6-db93-4dfb-927b-0d058e235e86" />
    <Caption mdxType="Caption">Use sentence case for labels.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/41b4bb4e-1709-4ddc-834c-9f474061b943" />
    <Caption mdxType="Caption">Don't use all-caps or other text formats.</Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Anatomy`}</h2>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/af85252d-783e-47dd-9b2c-ead0df0745b9",
        "alt": "An image showing different button types."
      }}></img></p>
    <h2>{`Options`}</h2>
    <h3>{`Variants`}</h3>
    <h4>{`Primary`}</h4>
    <p>{`Primary buttons have top priority in visual hierarchy, and using too many of them on a single view dilutes their effectiveness. We recommend to limit the primary button to one button per view, and place it in the visible section, whenever possible, to indicate its emphasis relative to other actions. Use multiple primary buttons only when the action is repeated in multiple places of the same page. E,g a "Log in" button in the header and in the footer area.`}</p>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/95d56f96-2453-41db-81f1-6c2e04568c26",
        "alt": "An image showing all primary states."
      }}></img></p>
    <h4>{`Secondary`}</h4>
    <p>{`Secondary buttons are the default button type. Use them for the main actions on a page or form. Secondary buttons are the most common button type and should be used in most cases. They can be paired with a primary button to perform a secondary action, or used on their own.`}</p>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/1acc8007-13a2-4083-b0f2-c1b4d5cf7b82",
        "alt": "An image showing all secondary states."
      }}></img></p>
    <h4>{`Subtle`}</h4>
    <p>{`Subtle buttons have a transparent background with translucent hover and active states, making them useful for compound components like `}<a parentName="p" {...{
        "href": "/components/ButtonGroup"
      }}>{`Button Group`}</a>{` when paired with secondary or primary variants.`}</p>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/7420969a-e561-4fd6-9bef-7340e2b0a7e8",
        "alt": "An image showing all subtle states."
      }}></img></p>
    <h3>{`Trailing and leading icons`}</h3>
    <p>{`You can place an icon inside the button in either the leading or the trailing position to enhance the visual context. It is recommended to use an use an `}<a parentName="p" {...{
        "href": "https://primer.style/octicons"
      }}>{`Octicon`}</a>{` here.`}</p>
    <p>{`Use a trailing visual if the button action involves selecting items (dropdown, select, filter, etc), and a leading visual to provide visual context to the adjacent label. E.g. Use a search icon for a search field submit action.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/2de44a58-fbf6-46bf-a645-5efd88da70dd" />
    <Caption mdxType="Caption">
      Use a leading icon that provides context and reinforces the label.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/9dba03c8-5a70-464c-9100-33a2205e4c26" />
    <Caption mdxType="Caption">
      Don't use a trailing icons to add a visual cue to the label. Use the
      leading icon for better scanability.
    </Caption>
  </Dont>
    </DoDontContainer>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/ef4c5d1c-abbb-477a-92d2-61a690924fc5" />
    <Caption mdxType="Caption">
      Use a trailing icon for select, dropdown, or filter actions to reinforce
      its direction.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/5c052c37-3482-4061-b399-97a455484e01" />
    <Caption mdxType="Caption">
      Don't use a leading icon or the arrow for select, dropdown, or filter
      actions.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Size`}</h3>
    <p>{`Button default to a medium size. Medium is suitable for most interfaces and is considered the preferred size.`}</p>
    <p>{`Large buttons increase the significance of an action and should be used sparingly. Use the large option when you need to emphasize the button on a big sized heading, for example in a `}<a parentName="p" {...{
        "href": "/components/Hero"
      }}>{`Hero`}</a>{` component.`}</p>
    <h3>{`Arrow`}</h3>
    <p>{`The arrow is shown by default in all buttons. Hide the arrow only to save horizontal space or to diminish the importance of the button.`}</p>
    <p>{`When used in a group, the arrow should be used or hide consistently across all buttons.`}</p>
    <h2>{`Accessibility`}</h2>
    <h3>{`Descriptive buttons`}</h3>
    <p>{`Labeling buttons properly lets users know what will happen when they activate the control, lessens errors, and increases confidence.`}</p>
    <p>{`Read more about `}<a parentName="p" {...{
        "href": "https://primer.style/design/guides/accessibility/descriptive-buttons/"
      }}>{`descriptive buttons`}</a>{`.`}</p>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/ButtonGroup"
        }}>{`ButtonGroup`}</a>{`: To display a group of related buttons.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/Link"
        }}>{`Link`}</a>{`: To display a link that navigates to another page.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/Hero"
        }}>{`Hero`}</a>{`: To display a large heading and a description with a ButtonGroup.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      